import styled from 'react-emotion';
import { get } from '@utils/theme';
export const Blockquote = styled('blockquote') `
  background: ${get('colors.blockquoteBg')};
  border-left: 5px solid ${get('colors.blockquoteBorder')};
  color: ${get('colors.blockquoteColor')};
  ${get('styles.blockquote')};

  & > p {
    margin: 0;
    color: ${get('colors.blockquoteColor')};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmxvY2txdW90ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jb21wb25lbnRzL3VpL0Jsb2NrcXVvdGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLGVBQWUsQ0FBQTtBQUNsQyxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sY0FBYyxDQUFBO0FBRWxDLE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBRyxNQUFNLENBQUMsWUFBWSxDQUFDLENBQUE7Z0JBQzlCLEdBQUcsQ0FBQyxxQkFBcUIsQ0FBQzsyQkFDZixHQUFHLENBQUMseUJBQXlCLENBQUM7V0FDOUMsR0FBRyxDQUFDLHdCQUF3QixDQUFDO0lBQ3BDLEdBQUcsQ0FBQyxtQkFBbUIsQ0FBQzs7OzthQUlmLEdBQUcsQ0FBQyx3QkFBd0IsQ0FBQzs7Q0FFekMsQ0FBQSJ9